import { useEffect, useState } from "react";
import { useImmersive } from "../../lib/immersiveMode";
import { useInFmScope } from "./fm/fmScope";

/** Mochi hides in immersive surfaces: an active call/pre-join and the Present
 *  slideshow register via immersiveMode; any Fullscreen element (the slideshow
 *  uses the Fullscreen API) also counts. A Files-area Mochi (its own
 *  launcher, the Create page, the voice call) also takes over (fmScope). */
export function useMochiSuppressed(): boolean {
  const immersive = useImmersive();
  const fmScope = useInFmScope();
  const [fs, setFs] = useState<boolean>(() => typeof document !== "undefined" && !!document.fullscreenElement);
  useEffect(() => {
    const onFs = () => setFs(!!document.fullscreenElement);
    document.addEventListener("fullscreenchange", onFs);
    return () => document.removeEventListener("fullscreenchange", onFs);
  }, []);
  return immersive || fs || fmScope;
}
